import React, { useEffect, useState } from "react"
import { api, checkEmptyObject } from "../../services";
import { useSelector } from "react-redux";
import { selectCategories } from "../../containers/App/selectors";
import { selectUserInfo } from "../../routes/Auth/auth.ducks";
import { Button } from "antd";
import ReactGA from 'react-ga4';
import { PageRoute, START_PAGE_PARAM, PromotionFromPages } from "../../models";
import { Link } from "react-router-dom";
import styles from "./myAddPromotion.scss"
import { getImageLink, getImageUrl } from "../../services/asset";
import config from 'appConfig';

const POSITION_LABELS = ["prvi oglas", "drugi oglas", "treći oglas"];
const TITLE_MAX_LENGTH = 20;

const truncateTitle = (title) => {
  if (!title) return "";
  if (title.length <= TITLE_MAX_LENGTH) return title;
  return title.slice(0, TITLE_MAX_LENGTH) + "…";
};

const normalizePagePositionResponse = (response) => {
  if (!response) return [];
  // BE may return an array of ads (new shape, up to 3) or a single ad object (legacy shape).
  if (Array.isArray(response)) {
    return response.filter(item => item && item.adId).slice(0, POSITION_LABELS.length);
  }
  if (response.adId) return [response];
  return [];
};

export const MyAdPromotion = ({ category, queryParams }) => {
  const [myAdPromotions, setMyAdPromotions] = useState([])
  const categories = useSelector(selectCategories)
  const userInfo = useSelector(selectUserInfo);

  const fetchCategoryPagePosition = async (categoryName) => {
    try {
      const response = await api.Ads.fetchCategoryPagePosition(categoryName);
      const ads = normalizePagePositionResponse(response);

      if (ads.length > 0) {
        setMyAdPromotions(ads);
        ads.forEach((_, index) => {
          ReactGA.event({
            category: "Promocija oglasa",
            action: "Click",
            label: `Prikazana poruka u pretrazi - ${POSITION_LABELS[index]}`
          });
        });
      }
    } catch (error) {
      setMyAdPromotions([])
    }
  }

  useEffect(() => {
    const foundCategory = categories.find(c => c.route === category)
    const categoryLv1Ids = queryParams.current && queryParams.current.filters && queryParams.current.filters.categoryLv1Ids
    const categoryLv2Ids = queryParams.current && queryParams.current.filters && queryParams.current.filters.categoryLv2Ids

    if (
      foundCategory &&
      !categoryLv1Ids &&
      !categoryLv2Ids &&
      checkEmptyObject(userInfo)
    ) {

      fetchCategoryPagePosition(foundCategory.name)
    }

    return () => {
      setMyAdPromotions([])
    }
  }, [queryParams.current, userInfo])

  const handleTrackClick = (index) => {
    ReactGA.event({
      category: "Promocija oglasa",
      action: "Click",
      label: `Aktivacija sa liste oglasa - ${POSITION_LABELS[index]}`
    });
  }

  if (myAdPromotions.length === 0) return null;

  return (
    <React.Fragment>
      {myAdPromotions.map((ad, index) => (
        <div key={ad.adId} className={styles.myAdPromotionWrapper}>
          <div className={styles.imageAndTitle}>
            <div className={styles.image} style={{
              backgroundImage: ad.imageName ?
                `url(${getImageLink(ad.imageName)})` :
                `url(${getImageUrl(config.imagePlaceholder)})`
            }} />
            <span>
              Tvoj oglas {ad.title && <strong>{`${truncateTitle(ad.title)} `}</strong>}se nalazi na <strong>{`${ad.pagePosition}. stranici`}</strong> kategorije. Istakni ga i podigni u vrh.
            </span>
          </div>
          <Link to={`${PageRoute.promote}/${ad.adId}?${START_PAGE_PARAM}=${PromotionFromPages.Search}`}>
            <Button type="primary" onClick={() => handleTrackClick(index)} size="large" className={styles.button}>Istakni oglas</Button>
          </Link>
        </div>
      ))}
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/MyAdPromotion/MyAdPromotion.tsx